export enum GsheetDetails {
  MEDICAL_PA_DASHBOARD = "1a701ZVsvPDsgX9JbTdxV9ibGBMM1AV5TMV42ARt7JDE",
  MEDICAL_PA_AUTH_SHEET = "AuthInaccuracy",
  MEDICAL_PA_EBBV_SHEET = "EvBvInaccuracy",
}
